var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-6 px-8"},[_c('h-header'),_c('AdminInvoicesHosts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }